import { render, staticRenderFns } from "./MessageCardTemplate.vue?vue&type=template&id=28d757b9&"
import script from "./MessageCardTemplate.vue?vue&type=script&lang=ts&"
export * from "./MessageCardTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports